// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__ErXuG","content":"Hero_content__ckNFl","text":"Hero_text__YfFnX","buttonContainer":"Hero_buttonContainer__r1t85"};